<template>
  <div
    style="border-radius: 5px; min-width: 200px; overflow: hidden; padding-left: 0px;"
    class="secondary elevation-2"
  >
    <v-select
      class="basemap-select"
      :items="basemaps"
      solo
      aria-label="Velg bakgrunnskart"           
      flat
      v-model="selectedBasemap"
      hide-details
      item-text="title"
      :return-object="true"
      item-avatar="thumbnailUrl"
    >
      <template slot="item" slot-scope="data">
        <v-list-tile-avatar>
          <img :alt="'Bakgrunnskart eksempel ' + data.item.title" :src="data.item.thumbnailUrl" />
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title v-html="data.item.title"></v-list-tile-title>
        </v-list-tile-content>
      </template>
      <template slot="selection" slot-scope="data">
        <v-list-tile-avatar>
          <img :alt="'Bakgrunnskart ' + data.item.title" :src="data.item.thumbnailUrl" class="basemap-select-avatar" />
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title v-html="data.item.title"></v-list-tile-title>
        </v-list-tile-content>
      </template>
    </v-select>
  </div>
</template>
<script>
import { mapState } from "vuex";
import BasemapMixin from "@/mixins/basemapMixin";
export default {
  name: "MapBasemapSelect",
  computed: {
    ...mapState(["basemaps"]),
    selectedBasemap: {
      set(selectedBasemap) {
        this.setBasemap(selectedBasemap);
      },
      get() {
        return this.$store.state.selectedBasemap;
      }
    }
  },
  data() {
    return {
      basemapsLoaded: false,
      loadedBasemaps: []
    };
  },
  mixins: [BasemapMixin]
};
</script>
<style>
.basemap-select {
  max-width: 215px;
  margin-top: 4px;
  z-index: 10000;
}

.basemap-select-avatar {
  padding: 0px;
  height: 10px;
}

.basemap-select .v-avatar {
  height: 30px !important;
  width: 30px !important;
}

.basemap-select .v-input__control {
  min-height: 42px !important;
}

.map-thumbnail::after {
  display: block;
  position: relative;
  background-image: linear-gradient(
    to bottom,
    transparent 50%,
    rgba(0, 0, 0, 0.788) 100%
  );

  width: 100%;
  content: "";
}
</style>
